import { render, staticRenderFns } from "./sxList.vue?vue&type=template&id=683d6238&scoped=true"
import script from "./sxList.vue?vue&type=script&lang=js"
export * from "./sxList.vue?vue&type=script&lang=js"
import style0 from "./sxList.vue?vue&type=style&index=0&id=683d6238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683d6238",
  null
  
)

export default component.exports